import { FC } from "react";
import type { ComponentProps } from "react";
import type Link from "next/link";
import { useRouter } from "next/router";

import ArrowLeftIcon from "@src/lib/icons/18px/arrow-left";
import { Button } from "@src/lib/ui/Button";

type LinkHref = ComponentProps<typeof Link>["href"];

type Props = {
  href: LinkHref;
  // Replace instead of push — for backs that unwind a sub-view, so browser
  // back doesn't reopen it.
  replace?: boolean;
};

/**
 * The shell's back arrow on the redesigned library item detail page
 * (Ff.LibraryItemOverviewTab): the same ghost 28px round button as the
 * editor's "Back to details" — the design system's ghost colours and hover,
 * no overrides.
 */
const BuilderHeaderBackButtonV2: FC<Props> = ({ href, replace = false }) => {
  const router = useRouter();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      aria-label="Back"
      className="shrink-0"
      onClick={() => (replace ? router.replace(href) : router.push(href))}
      data-testid="builder-header-back-button"
    >
      <ArrowLeftIcon className="size-3.5" />
    </Button>
  );
};

export default BuilderHeaderBackButtonV2;
